import {PINNED_RIGHT_EDGE_LINE_STYLE, ROW_BORDER_BOTTOM} from '../../constants/borderStyles';
import {DEFAULT_COL_WIDTH} from '../../constants/defaultColWidth';
import type {EagColumnState} from '../../types/EagColumnState';

export type SkeletonRowProps = {
  heightPx: number;
  columnStates: EagColumnState[];
  horizontalSeparators: boolean;
  actionColumnWidth?: number;
};

export function SkeletonRow(props: SkeletonRowProps) {
  return (
    <tr
      style={{
        height: props.heightPx,
        ...(props.horizontalSeparators ? ROW_BORDER_BOTTOM : undefined),
      }}
    >
      {/* left-pinned + unpinned skeleton cells */}
      {props.columnStates
        .filter((cs) => cs.pinned !== 'RIGHT')
        .map((colState) => {
          const width = colState.width ?? DEFAULT_COL_WIDTH;
          return (
            <td key={colState.key} className="p-2 border-0" style={{width, maxWidth: width}}>
              <div className="animate-pulse bg-gray-200 h-4 rounded w-full" />
            </td>
          );
        })}
      {/* filler td: absorbs remaining space between unpinned and right-pinned columns */}
      <td />
      {/* right-pinned skeleton cells */}
      {props.columnStates
        .filter((cs) => cs.pinned === 'RIGHT')
        .map((colState) => {
          const width = colState.width ?? DEFAULT_COL_WIDTH;
          return (
            <td key={colState.key} className="p-2 border-0" style={{width, maxWidth: width}}>
              <div className="animate-pulse bg-gray-200 h-4 rounded w-full" />
            </td>
          );
        })}
      {/* empty action column placeholder — maintains layout consistency with data rows */}
      {props.actionColumnWidth ? (
        <td
          style={{
            position: 'sticky' as const,
            right: 0,
            zIndex: 'var(--z-sidebar)',
            width: props.actionColumnWidth,
            maxWidth: props.actionColumnWidth,
          }}
          className="p-0 border-0 bg-white"
        >
          <span style={PINNED_RIGHT_EDGE_LINE_STYLE} />
        </td>
      ) : null}
    </tr>
  );
}
